import Vue from 'vue';
import { mapGetters } from 'vuex';
import CustomDividerUpload from './custom';

export default Vue.component('shape-divider-options', {
  template: require('./template.html'),
  name: 'shape-divider-options',
  components: {
    CustomDividerUpload,
  },
  computed: {
    ...mapGetters(['viewport', 'active-droplet']),
    isCustom() {
      return this.activeDroplet.shapeDividerCoords.type === 'custom';
    },
  },
  props: ['option', 'active-state', 'dom-nodes'],
  data() {
    return {
      dividerLocations: [
        'bottom',
        'top',
      ],
      dividerOptions: [
        'pointup',
        'slantleft',
        'slantright',
        'waveone',
        'wavetwo',
        'curve',
        'custom',
      ],
      display: {
        divider: false,
        dividerLocation: 'bottom',
      },
      debTime: 250,
      innerDomNodes: {},
    };
  },
  watch: {
    viewport() {
      this.setInitialValue();
    },
    activeState() {
      this.setInitialValue();
    },
  },
  created() {
    // then check for previous values
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      this.display.divider = this.activeDroplet.shapeDivider;
      this.display.dividerLocation = this.activeDroplet.shapeDividerCoords.location;
    },
    setShapeDivider(shape) {
      this.$store.dispatch('setDropletVal', {
        drp: this.activeDroplet.shapeDividerCoords,
        key: 'type',
        val: shape,
      });
      this.$emit('update-changes', true);
    },
    updateDividerLocation() {
      this.$store.dispatch('setDropletVal', {
        drp: this.activeDroplet.shapeDividerCoords,
        key: 'location',
        val: this.display.dividerLocation,
      });
      this.$emit('update-changes', true);
    },
    updateDivider() {
      this.$store.dispatch('setDropletVal', {
        drp: this.activeDroplet,
        key: 'shapeDivider',
        val: this.display.divider,
      });
      this.$emit('update-changes', true);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/style-sidebar/options/section-options/shape-dividers/index.js